import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import { finalCtaData } from '../../data/mock';

const FinalCTASection = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="py-32 bg-[#202020] relative overflow-hidden"
    >
      {/* Background Image */}
      {/* <div className="absolute inset-0 opacity-20">
        <img 
          src="https://images.unsplash.com/photo-1476703993599-0035a21b17a9?w=1200&q=80" 
          alt=""
          className="w-full h-full object-cover grayscale"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#202020] via-[#202020]/80 to-[#202020]" />
      </div> */}

      <div className="max-w-4xl mx-auto px-8 text-center relative z-10">
        {/* Title */}
        <h2 className={`text-3xl md:text-4xl lg:text-5xl font-normal text-[#efede6] mb-12 leading-tight tracking-tight transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          {finalCtaData.title}
        </h2>

        {/* Highlight */}
        <div className={`bg-[#efede6]/5 rounded-2xl p-10 mb-12 max-w-2xl mx-auto border border-[#efede6]/10 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <p className="text-xl text-[#efede6] leading-relaxed">
            {finalCtaData.highlight}
          </p>
        </div>

        {/* CTA Button */}
        <div className={`mb-12 transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <Button 
            onClick={() => navigate('/checkout')}
            className="bg-[#efede6] text-[#202020] hover:bg-white text-base font-medium px-10 py-6 rounded-lg transition-all duration-300 hover:scale-105 group"
          >
            {finalCtaData.ctaText}
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>

        {/* Disclaimer */}
        <div className={`space-y-2 transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          {finalCtaData.disclaimer.map((line, index) => (
            <p key={index} className={`text-[#efede6]/${index === 0 ? '60' : '40'}`}>
              {line}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
